import React, { useRef, useEffect } from "react";
import ReactDOM from "react-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import nl2br from "@/shared/nl2br";
import "swiper/css";
import "swiper/css/navigation";

const PortfolioModal = ({ portfolios, selectedPortfolio, onClose }) => {
  // 選択された思い出のストーリーのインデックスを取得
  const initialSlideIndex = portfolios.findIndex(
    (portfolio) => portfolio.id === selectedPortfolio.id,
  );
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const swiperRef = useRef(null);
  const contentRef = useRef(null);

  // 各スライドへのref
  const slideRefs = useRef([]);

  useEffect(() => {
    document.body.classList.add("modal-open");
    return () => {
      document.body.classList.remove("modal-open");
    };
  }, []);

  // スライド変更時の処理
  const handleSlideChange = (swiper) => {
    const { realIndex } = swiper;
    const currentSlide = slideRefs.current[realIndex];

    if (contentRef.current) {
      contentRef.current.scrollTop = 0;
    }

    if (currentSlide && contentRef.current) {
      const slideContentHeight = currentSlide.scrollHeight;
      const containerHeight = window.innerHeight;

      if (slideContentHeight > containerHeight) {
        contentRef.current.style.overflowY = "scroll";
      } else {
        contentRef.current.style.overflowY = "hidden";
      }
    }
  };

  return ReactDOM.createPortal(
    <div className="concept-story-modal">
      <span className="concept-story-modal__close" onClick={onClose}>
        ×
      </span>
      <div className="concept-story-modal__prev" ref={prevRef}></div>
      <div className="concept-story-modal__next" ref={nextRef}></div>
      <div className="concept-story-modal__content" ref={contentRef}>
        <Swiper
          className="concept-story-modal__swiper"
          modules={[Navigation]}
          initialSlide={initialSlideIndex}
          slidesPerView={1}
          loop={true}
          navigation={{
            prevEl: prevRef.current,
            nextEl: nextRef.current,
          }}
          onBeforeInit={(swiper) => {
            const { params } = swiper;
            params.navigation.prevEl = prevRef.current;
            params.navigation.nextEl = nextRef.current;
          }}
          onSwiper={(swiper) => {
            swiperRef.current = swiper;
            swiper.navigation.init();
            swiper.navigation.update();
          }}
          onSlideChange={handleSlideChange}
          touchStartPreventDefault={false}
        >
          {portfolios.map((portfolio, index) => (
            <SwiperSlide key={portfolio.id}>
              <div
                className="concept-story-modal__slide"
                ref={(el) => {
                  slideRefs.current[index] = el;
                }}
              >
                <div className="concept-story-modal__detail">
                  <img
                    src={portfolio.image.modal_image_url}
                    alt={`${portfolio.staff.name}の思い出のストーリー`}
                    onLoad={() => {
                      if (swiperRef.current?.realIndex === index) {
                        handleSlideChange(swiperRef.current);
                      }
                    }}
                  />
                  <p className="concept-story-modal__text special__text">
                    {nl2br(portfolio.content)}
                  </p>
                  <p className="concept-story-modal__name font-family--middle">
                    {portfolio.staff.name}
                  </p>
                  <p className="concept-story-modal__profession font-family--middle">
                    {portfolio.staff.role}
                  </p>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>,
    document.body, // モーダルをルート外にレンダリング
  );
};

export default PortfolioModal;
